import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import DuplicarRodadaDialog from "../DuplicarRodadaDialog";

/**
 * Botão de ação para duplicar uma rodada, usado na coluna de ações da tabela de consulta.
 * Cada instância gerencia seu próprio estado de dialog.
 */
export default function BotaoDuplicarRodada({ rodada, onDuplicated }) {
    const [open, setOpen] = useState(false);

    const handleClick = (e) => {
        // Impede que o clique propague para o onRowClick da tabela
        e.stopPropagation();
        setOpen(true);
    };

    const handleClose = (result) => {
        setOpen(false);
        if (result?.duplicated && onDuplicated) {
            onDuplicated(result);
        }
    };

    return (
        <>
            <Tooltip title="Duplicar Rodada">
                <IconButton
                    size="small"
                    onClick={handleClick}
                    color="primary"
                >
                    <ContentCopy fontSize="small" />
                </IconButton>
            </Tooltip>

            {open && (
                <DuplicarRodadaDialog
                    rodada={rodada}
                    open={true}
                    onClose={handleClose}
                    showRedirect={false}
                />
            )}
        </>
    );
}
